import React from 'react';
import { VitalIndicatorSC } from './vital-indicator.styled';

type TProps = {
  degree: number;
  color: string;
};

const VitalChartDot: React.FC<TProps> = ({ degree, color }) => {
  return (
    <div
      style={{
        transform: `rotate(-40deg) rotate(${(degree / 270) * (degree - 10)}deg)`,
        position: 'absolute',
        height: 10,
        width: 98,
      }}
    >
      <VitalIndicatorSC color={color} />
    </div>
  );
};

export default React.memo(VitalChartDot);
